import NavFooter from 'ext-ui/components/NavFooter/NavFooter'
import {
  base_colorContentBorder,
  base_contentBackground,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slower } from 'ext-ui/style/transitionSpeeds'
import styled, { css } from 'styled-components'

export const sidenavBottomContainer = css`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  background-color: ${base_contentBackground};
  padding: ${spacing(3)} 0;
  z-index: 2;
  position: sticky;
  gap: ${spacing(1)};
  border-top: 1px solid ${base_colorContentBorder};
`

export const SidenavAdsNavFooter = styled(NavFooter)`
  && {
    ${sidenavBottomContainer};
    border-right: 0;
    width: 100%;
  }

  &&.minimized,
  &&.not-minimized {
    width: 100%;
  }
`

export const sidenavLogoContainer = css`
  display: flex;
  align-items: center;
  padding: ${spacing(1)} 0;
  transition: margin ${transition_slower} ease-out;

  &.open {
    margin-left: ${spacing(4)};
  }
  &.closed {
    margin-left: ${spacing(2.5)};
  }
`

export const sidenavLogoInner = css`
  padding-left: ${spacing(1)};
  padding-top: 5px;
  position: relative;
`

export const sidenavBrandMarkContainer = css`
  position: absolute;
  left: -6px;
  top: -3px;
  transition: opacity ${transition_slower} ease-out;

  &.open {
    opacity: 0;
  }
  &.closed {
    opacity: 1;
  }
`

export const sidenavBrandLogoContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
`

export const sidenavBrandLogo = css`
  height: ${spacing(4)};
  transition: opacity ${transition_slower} ease-out;

  &.open {
    opacity: 1;
  }
  &.closed {
    opacity: 0;
  }
`
